import React, { useState, useEffect } from 'react';
import MasterTypeList from './MasterTypeList';

const CONFERENCE_API = process.env.REACT_APP_CONFERENCE_API_URL || 'http://localhost:8080/conference';

const MasterData = () => {
  const [conferences, setConferences] = useState([]);
  const [selectedConferenceId, setSelectedConferenceId] = useState('');
  const [selectedConference, setSelectedConference] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch active conferences on mount
  useEffect(() => {
    fetchActiveConferences();
  }, []);

  // Fetch conference details when selection ID changes
  useEffect(() => {
    if (selectedConferenceId) {
      fetchConferenceDetails(selectedConferenceId);
    }
  }, [selectedConferenceId]);

  const fetchActiveConferences = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${CONFERENCE_API}/active`);
      if (response.ok) {
        const data = await response.json();
        setConferences(data);
      } else {
        console.error('Failed to fetch active conferences');
      }
    } catch (error) {
      console.error('Error fetching active conferences:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchConferenceDetails = async (conferenceId) => {
    try {
      const response = await fetch(`${CONFERENCE_API}/${conferenceId}`);
      if (response.ok) {
        const data = await response.json();
        setSelectedConference(data);
      } else {
        console.error('Failed to fetch conference details');
      }
    } catch (error) {
      console.error('Error fetching conference details:', error);
    }
  };

  const renderTabContent = () => {
    if (!selectedConference?.id) {
      return (
        <div style={{ padding: '40px', textAlign: 'center', color: '#7f8c8d' }}>
          <p>Please select a conference to manage master data</p>
        </div>
      );
    }

    return <MasterTypeList conferenceId={selectedConference.id} />;
  };

  return (
    <div>
      <div className="content-header">
        <h1>Master Data Management</h1>
        <div className="breadcrumb">Admin / Master Data</div>
      </div>

      <div className="content-body">
        {/* Conference Selection */}
        <div style={{ 
          marginBottom: '30px', 
          padding: '20px', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '8px',
          border: '1px solid #dee2e6'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <label style={{ fontWeight: '600', fontSize: '14px', color: '#2c3e50' }}>
              Select Conference:
            </label>
            <select
              value={selectedConferenceId}
              onChange={(e) => {
                const conferenceId = e.target.value;
                setSelectedConferenceId(conferenceId);
                const conf = conferences.find(c => c.id.toString() === conferenceId);
                setSelectedConference(conf || null);
              }}
              disabled={loading}
              style={{
                padding: '10px 15px',
                fontSize: '14px',
                border: '1px solid #ced4da',
                borderRadius: '4px',
                backgroundColor: 'white',
                minWidth: '250px',
                cursor: 'pointer'
              }}
            >
              <option value="">All Conferences</option>
              {conferences.map(conf => (
                <option key={conf.id} value={conf.id}>
                  {conf.name}
                </option>
              ))}
            </select>
            
            {selectedConference && (
              <div style={{ 
                marginLeft: '10px',
                padding: '8px 15px',
                backgroundColor: '#e3f2fd',
                borderRadius: '4px',
                fontSize: '13px',
                color: '#1976d2'
              }}>
                <strong>{selectedConference.name}</strong>
                {selectedConference.place && ` • ${selectedConference.place}`}
              </div>
            )}
          </div>
        </div>



        {renderTabContent()}
      </div>
    </div>
  );
};

export default MasterData;
